import { Typography } from '../../../../components/Typography'
import { useMemo } from 'react'
import {
  LED_BY_LABEL,
  LED_BY_VALUE
} from '../../../../components/LeadByIndicator/constants'
import { LedByUnion } from '../../../ContractCategoryDetails/types'
import { LeadByIndicator } from '../../../../components/LeadByIndicator'
import { ROLES } from '../../../Permission'

export const SelectPayorRecipientPopoverContent = ({
  userRole,
  onDownload,
  ledBy
}: {
  userRole: string
  onDownload: (ledByOption: LedByUnion) => void
  ledBy?: LedByUnion
}) => {
  const downloadOptions: LedByUnion[] = useMemo(() => {
    switch (userRole) {
      case ROLES.COMMONS_VICE_PRESIDENT:
      case ROLES.COMMONS_CONTRACT_STEWARD:
      case ROLES.COMMONS_ANALYST:
        return [
          ledBy === LED_BY_VALUE.COMMUNITY
            ? LED_BY_VALUE.NATIONAL_GPO
            : LED_BY_VALUE.COMMUNITY,
          LED_BY_VALUE.HEALTH_SYSTEM
        ]
      case ROLES.GPO_PRESIDENT:
      case ROLES.GPO_ANALYST:
      case ROLES.GPO_FINANCE_OFFICER:
      case ROLES.GPO_CONTRACT_STEWARD:
        return [LED_BY_VALUE.COMMUNITY, LED_BY_VALUE.HEALTH_SYSTEM]
      case ROLES.COMMUNITY_PRESIDENT:
        return [LED_BY_VALUE.NATIONAL_GPO, LED_BY_VALUE.HEALTH_SYSTEM]
      default:
        return []
    }
  }, [userRole, ledBy])
  return (
    <div className="column">
      {downloadOptions.map((option, key) => {
        return (
          <div
            className="row align-center gap-6 p-8 clickable-item"
            onClick={() => onDownload(option)}
            key={key}
          >
            <LeadByIndicator value={option} smallSize />
            <Typography.Body1>
              {LED_BY_LABEL[option]} recipient
            </Typography.Body1>
          </div>
        )
      })}
    </div>
  )
}
